<app-landingpage-header-child></app-landingpage-header-child>
<nz-layout>
  <nz-content>
    <div class="pl-3 pr-3">

      <div *ngIf="!isShowPDFViewer">

        <div class="container captionblock">
          <div class="row">
            <div class="toolsign">
              <a>
                <i style="font-size: 7em;" nz-icon nzType="safety-certificate" [nzTheme]="'twotone'"
                   [nzTwotoneColor]="'#52c41a'"></i>
              </a>
            </div>
            <div class="toolscapt">
              <h1>{{'header.contract_verify' | translate }}</h1>
              <span class="toolscaptdesc">{{'header.contract_verify_description' | translate}}</span>
            </div>
          </div>
        </div>
        <div class="drd-container container" [style.background-color]="background">
          <input style="cursor: pointer;" type="file" #fileDropRef id="fileDropRef" (change)="onSelectedUpload($event)"
                 (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="ondrop($event)" multiple
                 accept="application/pdf" title=""/>
          <img class="pb-3" src="assets/images/ic-upload-file.svg" alt="">
          <h3 class="pb-3" class="color-primary">{{'header.drag_and_drop_file'| translate}}</h3>
          <h3 class="pb-3" class="color-dark">{{'header.or'| translate}}</h3>
          <button mat-stroked-button class="mr-2" color="primary" type="button"
                  [ngClass]="{'active_document' : this.panelDocumentComponent.valueSelect == 1}" [disabled]="flagCopy">
            <mat-icon class="mr-2">cloud_upload</mat-icon>
            {{'button.choose_a_file' | translate}}
          </button>

          <h5 style="margin-top:2em;">({{'validation.validate_file_type_file_size'| translate}})</h5>
        </div>
      </div>
      <section>
        <div style="margin-top:1rem;">
          <div style="overflow: hidden" *ngIf="isShowPDFViewer">
            <div class="row">
              <div class="col-12 pl-0" style="padding-right: 0.75rem;">
                <div class="bg-white text-right mat-elevation-z0 py-2 px-3">
                  <button #btnUpload id="btnUpload" mat-stroked-button class="mr-2" color="primary" type="button"
                          (click)="inputUpload.click()"
                          [ngClass]="{'active_document' : this.panelDocumentComponent.valueSelect == 1}"
                          [disabled]="flagCopy">
                    <mat-icon class="mr-2">cloud_upload</mat-icon>
                    {{'button.select_orther_file' | translate}}
                  </button>
                  <input type="file" #inputUpload id="file" accept="application/pdf" multiple
                         class="form-control-file vt-input-form d-none" name="file"
                         (change)="onSelectedUpload($event)"/>
                </div>

                <hr style="margin: 0;">
                <div class="row">
                  <div
                    [ngClass]="{'col-md-12 col-lg-9 col-xl-9': this.isHasResponse, 'col-md-12 col-lg-12 col-xl-12': !this.isHasResponse && this.isShowPDFViewer}"
                    class="document py-3 pr-0" id="pdfContainer" style="height: calc(100vh - 180px);">
                    <ng-container
                      *ngIf="this.panelDocumentComponent.valueSelect == 1 && this.panelDocumentComponent.valueSelect != null; else notUpload">
                      <ng-container *ngIf="this.pdfSrc != ''">
                        <div style="padding: 0 10px 0 20px">
                          <ngx-extended-pdf-viewer
                            [src]="pdfSrc"
                            [(zoom)]="zoomLevel"
                            useBrowserLocale="true"
                            height="80vh"
                            [enablePrint]="false"
                            [language]="language"
                            [showDownloadButton]="false"
                            [showRotateButton]="false"
                            [showOpenFileButton]="false"
                            [showBookmarkButton]="false"
                            [showPropertiesButton]="false"
                            [showUnverifiedSignatures]="true"
                            [theme]="'dark'"
                            [showSidebarButton]="isShowSidebarButton"
                          ></ngx-extended-pdf-viewer>
                        </div>
                      </ng-container>
                    </ng-container>
                    <ng-template #notUpload>
                      <app-display-template>
                      </app-display-template>
                    </ng-template>
                  </div>
                  <div class="col-md-12 col-lg-3 col-xl-3 pr-0" *ngIf="isHasResponse">
                    <div class="card content-panel-document-info">
                      <app-panel-document-info [signatureInfo]="signatureInfo" (hasChange)="onPanelChange($event)">
                      </app-panel-document-info>
                    </div>
                  </div>
                </div>
                <hr style="margin: 0;">
                <div class="bg-white text-center mat-elevation-z0 py-2">
                  <button mat-stroked-button color="primary" class="mr-3" type="button" (click)="onBackClick()">
                    <mat-icon class="mr-2">arrow_back</mat-icon>
                    {{'form.back' | translate}}
                  </button>
                  <button mat-raised-button [disabled]="isDisable" (click)="onClickBtnSave()" type="button"
                          color="primary">
                    <mat-icon class="mr-2">check_circle_outline</mat-icon>
                    {{'button.authenticate' | translate}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </nz-content>
  <app-landingpage-footer></app-landingpage-footer>
</nz-layout>
